<template>
  <div ref="contentRoot" class="book-section-content">
    <article v-for="item in contents" :key="item.id" class="mb-4">
      <h2 v-if="item.contentTitle || item.fileTitle" class="h5">{{ item.contentTitle || item.fileTitle }}</h2>
      <div v-if="item.fileType === 2" v-html="item.contentHtml"></div>
      <img v-else-if="item.fileType === 1" :src="mediaUrl(item, 'image')" :alt="item.contentTitle || item.fileTitle || ''" loading="lazy">
      <audio v-else-if="item.fileType === 4" :src="mediaUrl(item, 'audio')" controls preload="none"></audio>
      <video v-else-if="item.fileType === 5" :src="mediaUrl(item, 'video')" controls playsinline preload="none"></video>
    </article>
  </div>
</template>

<script>
export default {
  props: {contents: {type: Array, default: () => []}},
  methods: {
    mediaUrl(item, kind) {
      return `${process.env.VUE_APP_ROOT_API}Source/book/${kind}?fileName=${encodeURIComponent(item.fileName)}`;
    },
    stopMedia() { this.$refs.contentRoot?.querySelectorAll('audio, video').forEach(player => player.pause()); },
  },
  beforeUnmount() { this.stopMedia(); },
};
</script>

<style scoped>
.book-section-content img, .book-section-content video { max-width: 100%; height: auto; }
.book-section-content video { width: 100%; max-height: 560px; }
.book-section-content audio { width: 100%; }
.book-section-content { overflow-wrap: anywhere; }
</style>
